import React, { useState, useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import axiosInstance from '@/lib/axios';

interface RoleDropdownProps {
  value: string;
  onValueChange: (value: string) => void;
  roles?: Array<{ _id?: string, id?: string, name: string }>;
  placeholder?: string;
  className?: string;
}

const RoleDropdown: React.FC<RoleDropdownProps> = ({ value, onValueChange, roles: rolesFromProps, placeholder, className }) => {
  const [roles, setRoles] = useState<any[]>(rolesFromProps || []);

  useEffect(() => {
    // If roles are passed via props, use them directly.
    if (rolesFromProps) {
      setRoles(rolesFromProps);
      return;
    }

    // Fallback to fetch roles only if not provided.
    const fetchRoles = async () => {
      try {
        const response = await axiosInstance.get('/roles');
        const rolesData = response.data.data || (Array.isArray(response.data) ? response.data : []);
        setRoles(rolesData);
      } catch (error: any) {
        if (error.response && error.response.status === 403) {
        } else {
          console.error('Error fetching roles:', error);
        }
      }
    };

    fetchRoles();
  }, [rolesFromProps]);

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={`h-10 rounded-lg border-gray-200 focus:border-blue-500 focus:ring-blue-500 text-sm w-full bg-white ${className}`}>
        <SelectValue placeholder={placeholder || "Select Role"} />
      </SelectTrigger>
      <SelectContent>
        {!value || value === "no-role" || value === "All" ? (
          <SelectItem value="no-role">Select Role</SelectItem>
        ) : null}
        {roles.map((role, index) => (
          <SelectItem key={role.id || role._id || index} value={role.name}>
            {role.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default RoleDropdown; 